import { useEffect } from "react";

export function LinkToYouleap() {
  useEffect(() => {
    window.location.href = "https://youleap.io";
  }, []);

  return null;
}
